export default __webpack_public_path__ + "static/media/remove.8e43d171.svg";